<template>
  <div class="animated fadeIn disable-text-select" @keyup.enter="onFilter"
    style="overflow: auto;  padding-bottom: 6rem; padding-left: 4px; padding-right: 4px;">
    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterAssociado === true ? showFilterAssociado = false : showFilterAssociado = true">
          <i v-if="showFilterAssociado" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Associado</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small> </div>-->
      </div>
    </div>
    <div v-if="showFilterAssociado">
      <div class="form-group row">
        <div class="w-100">
          <label> CPF/CNPJ:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Digite o CPF ou CNPJ'" v-model="form.document.value"
              :state="form.document.state" autofocus />
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Nome:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Digite o nome'" v-model="form.nome.value" :state="form.nome.state" />
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterInstituicao === true ? showFilterInstituicao = false : showFilterInstituicao = true">
          <i v-if="showFilterInstituicao" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Instituição</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small></div>-->
      </div>
    </div>
    <div v-if="showFilterInstituicao">
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> PA:</label>
          <div class="input-group">
            <v-select v-model="numberPA.selected" :options="numberPA.listOptions" class="w-100" label="text"
              placeholder="Selecione o PA">
              <template v-slot:no-options>Nenhum PA encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Regional:</label>
          <div class="input-group">
            <v-select v-model="regionalName.selected" :options="regionalName.listOptions" class="w-100" label="text"
              placeholder="Selecione a regional">
              <template v-slot:no-options>Nenhum PA encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Gerente:</label>
          <div class="input-group w-100">
            <v-select multiple v-model="employee.selected" :options="employee.listOptions" class="w-100" label="text"
              placeholder="Selecione o gerente">
              <template v-slot:no-options>Nenhum Gerente encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterResponsavel === true ? showFilterResponsavel = false : showFilterResponsavel = true">
          <i v-if="showFilterResponsavel" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Responsáveis</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small> </div>-->
      </div>
    </div>
    <div v-if="showFilterResponsavel">
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Responsáveis:</label>
          <div class="input-group">
            <v-select multiple v-model="responsible.selected" :options="responsible.listOptions" class="w-100"
              label="text" placeholder="Selecione a pessoa responsável">
              <template v-slot:no-options>Nenhum Reponsável encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Grupos Responsáveis:</label>
          <div class="input-group">
            <v-select multiple v-model="groupResponsible.selected" :options="groupResponsible.listOptions" class="w-100"
              label="text" placeholder="Selecione o grupo responsável">
              <template v-slot:no-options>Nenhum grupo encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterProduct === true ? showFilterProduct = false : showFilterProduct = true">
          <i v-if="showFilterProduct" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Produto</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small></div> -->
      </div>
    </div>
    <div v-if="showFilterProduct">
      <div class="form-group row pb-2 w-100">
        <label> Operação:</label>
        <div class="input-group">
          <b-form-input v-model="form.operacao.value" placeholder="Digite a operação" class="w-100" type="text" />
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Produtos:</label>
          <div class="input-group">
            <v-select multiple v-model="product.selected" :options="product.listOptions" placeholder="Selecione o produto"
              class="w-100" label="text">
              <template v-slot:no-options>Nenhum produto encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div>
          <label> Valor do produto:</label>
          <div class="input-group">
            <money placeholder="$lang.Currency.Placeholder" class="form-control text-bold" max-length="12"
              v-model.lazy="form.valorInicial.value" v-bind="$lang.Currency.Format"></money>
            <money placeholder="$lang.Currency.Placeholder" class="form-control text-bold" max-length="12"
              v-model.lazy="form.valorFinal.value" v-bind="$lang.Currency.Format"></money>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div>
          <label> Dias em atraso:</label>
          <div class="input-group">
            <b-form-input v-model="form.diasAtrasoInicio.value" :state="form.diasAtrasoInicio.state" placeholder="De"
              type="number" />
            <b-form-input v-model="form.diasAtrasoFinal.value" :state="form.diasAtrasoFinal.state" placeholder="Até"
              type="number" />
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterCobranca === true ? showFilterCobranca = false : showFilterCobranca = true">
          <i v-if="showFilterCobranca" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Cobrança</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small></div> -->
      </div>
    </div>
    <div v-if="showFilterCobranca">
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Quadros:</label>
          <div class="input-group">
            <b-form-select v-model="boardId.value" :options="boardId.listOptions" placeholder="Selecione o quadro"
              class="w-100" label="text">
              <!-- <template v-slot:no-options>Nenhum quadro encontrado.</template> -->
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Risco Sicoob:</label>
          <div class="input-group">
            <v-select multiple v-model="sicoobRisk.selected" :options="sicoobRisk.listOptions" class="w-100" label="text"
              placeholder="Selecione os índices">
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Risco Bacen:</label>
          <div class="input-group">
            <v-select multiple v-model="bacenRisk.selected" :options="bacenRisk.listOptions" class="w-100" label="text"
              placeholder="Selecione os índices">
            </v-select>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterInteracao === true ? showFilterInteracao = false : showFilterInteracao = true">
          <i v-if="showFilterInteracao" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Interação</label>
      </div>
    </div>
    <div v-if="showFilterInteracao">
      <!-- <div class="form-group row pb-2">
        <div class="w-100">
          <label> Interação:</label>
          <div class="input-group">
            <b-form-select v-model="form.interacao.value" :options="form.interacao.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div> -->
      <div class="form-group row pb-2">
        <div class="w-100">
            <label>Data Mínima:</label>
            <NxDatePicker
              :placeholder="$lang.Common.DatePlaceholder"
              v-model="form.dataInteracaoInicial.value"
              :maxlength="form.dataInteracaoInicial.maxlength"
              :required="form.dataInteracaoInicial.required"
              :state="form.dataInteracaoInicial.state"
            />
            <label>Data Máxima:</label>
            <NxDatePicker
              :placeholder="$lang.Common.DatePlaceholder"
              v-model="form.dataInteracaoFinal.value"
              :maxlength="form.dataInteracaoFinal.maxlength"
              :required="form.dataInteracaoFinal.required"
              :state="form.dataInteracaoFinal.state"
            />
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="w-100 pt-2">
        <button type="button" class="btn rounded-4 btn-third w-100" v-on:click="onFilter">
          Filtrar
        </button>
      </div>
      <div class="w-100 pt-2">
        <button type="button" class="btn rounded-4 btn-default w-100" v-on:click="onClearFilters">
          Limpar Filtros
        </button>
      </div>
    </div>
    <!-- <div class="form-group row" style="margin-top: 600px;">&nbsp;</div> -->
  </div>
</template>

<script>
import CardSearch from './search.js'
export default CardSearch
</script>

<style lang="scss" scoped>
.disable-text-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.animated.fadeIn {
  padding-bottom: 2rem;
}

.animated.fadeIn::-webkit-scrollbar {
  display: none;
}

.form-group {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/cobranca/search/search.vue